module.exports = __webpack_public_path__ + "static/media/no_connection.ade9f8dc.png";